module.exports = __webpack_public_path__ + "img/logo-vidvie.ea79c02d.png";